import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FixedWarning } from './FixedWarning'

export default function OfflineAlert() {
	const { t } = useTranslation()

	let [disconnected, changeDisconnected] = useState(!navigator.onLine)
	useEffect(() => {
		window.onoffline = () => changeDisconnected(true)
		window.ononline  = () => changeDisconnected(false)
	}, [disconnected])

	return <FixedWarning icon="wifi-slash" show={disconnected} children={t('Looks like you are offline.')}/>
}
